import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="relative bg-navy-dark py-24 md:py-36 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-teal/10 blur-3xl pointer-events-none" />
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center relative">
        <Reveal>
          <h2 className="font-display font-extrabold tracking-[-0.03em] text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            Got something that
            <br />
            <span className="text-teal-light">needs doing?</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-slate-300 max-w-xl mx-auto leading-relaxed">
            Find someone you can trust to get it done.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href="#app"
              data-testid="final-post-job-btn"
              className="group inline-flex items-center justify-center gap-2 bg-teal hover:bg-teal-hover text-navy font-semibold px-9 py-4 rounded-full shadow-lg shadow-teal/25 transition-colors duration-200"
            >
              Post a Job
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
            </a>
            <a
              href="#app"
              data-testid="final-become-tasker-btn"
              className="inline-flex items-center justify-center gap-2 border border-white/25 hover:border-white/60 text-white font-semibold px-9 py-4 rounded-full transition-colors duration-200"
            >
              Become a Tasker
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
